export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_NAVIGATE_SCHEMA = 'SET_NAVIGATE_SCHEMA'
export const SET_APP_MENUS = 'SET_APP_MENUS'
export const SET_TAB_MENUS = 'SET_TAB_MENUS'
export const ADD_TAB_MENUS = 'ADD_TAB_MENUS'
export const REMOVE_TAB_MENUS = 'REMOVE_TAB_MENUS'
export const SET_ACTIVE_TAB_MENU = 'SET_ACTIVE_TAB_MENU'
export const UPDATE_TAB_MENU_ITEM = 'UPDATE_TAB_MENU_ITEM'
export const SET_USER_NAME = 'SET_USER_NAME'
export const SET_TODO_MENU_ID = 'SET_TODO_MENU_ID'
export const SET_MESSAGE_MENU_ID = 'SET_MESSAGE_MENU_ID'
export const SET_TAGS_DISPLAYBOARD = 'SET_TAGS_DISPLAYBOARD'
export const SET_EXTEND_DATA = 'SET_EXTEND_DATA'
export const SET_SYSTEMT_MENUS = 'SET_SYSTEMT_MENUS'
export const SET_PERSONAL_MENUS = 'SET_PERSONAL_MENUS'
export const SET_BASICINFO = 'SET_BASICINFO'
export const POST_MSG_TO_ACTIFRAME = 'POST_MSG_TO_ACTIFRAME'
export const SET_VIEW_TYPE = 'SET_VIEW_TYPE'
export const SORT_NAV_TAB_MENU = 'SORT_NAV_TAB_MENU'
